/**
 * Handle Scroll Spy Nav 
 */

window.addEventListener('load', handleScroll);
window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', handleScroll);
const scrollSpyMainNav = document.querySelectorAll<HTMLElement>('.js-scroll-spy-main-nav');
const scrollSpySubNav = document.querySelectorAll<HTMLElement>('.js-scroll-spy-sub-nav');
const navLinks = document.querySelectorAll('.js-scroll-spy-nav a');

function handleScroll() {
    if (scrollSpyMainNav && scrollSpyMainNav[0]) {
        const windowScroll = window.scrollY;
        const scrollSpyMainNavHeight = scrollSpyMainNav[0].offsetHeight;
        const stickyNavThreshold = scrollSpyMainNavHeight;
        const scrollSpySubNavOffset = scrollSpySubNav[0].getBoundingClientRect().top + window.scrollY;
        
        if (windowScroll >= scrollSpySubNavOffset) {
            scrollSpyMainNav[0].classList.add('is-active');
        } else {
            scrollSpyMainNav[0].classList.remove('is-active');
        }
        
        navLinks?.forEach(function (navLink) {
            const section = document.querySelector<HTMLElement>(navLink.getAttribute('href') ?? '');

            if (section) {
                const sectionOffset = section.getBoundingClientRect().top + window.scrollY;
                const sectionHeight = section.offsetHeight;
                const sectionBottom = sectionHeight + sectionOffset;

                if (windowScroll - 12 < sectionBottom - stickyNavThreshold && windowScroll + 20 >= sectionOffset - stickyNavThreshold) {
                    navLink.parentElement?.classList.add('is-active');
                } else {
                    navLink.parentElement?.classList.remove('is-active');
                }
            }
        })
    }
}

//addEventListener('click', function (event) {
//    let el = event.target as HTMLElement;

//	if (el.tagName === 'A' && el.classList.contains('js-scroll-spy-nav')) {
//		event.preventDefault();

//		var topOffset = anchorContent.getBoundingClientRect().top + window.scrollY;

//		$('html, body').animate({ scrollTop: topOffset - 70 }, 500);
//	}
//})
